export const environment = process.env.REACT_APP_TELIUM_ENVIRONMENT || 'qa';
export const account = process.env.REACT_APP_TELIUM_ACCOUNT || 'nib';
export const profile = process.env.REACT_APP_TELIUM_PROFILE || 'main';
